"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Container: () => Container,
  Implements: () => Implements,
  Injectable: () => Injectable,
  Service: () => Service,
  ServiceCollection: () => ServiceCollection,
  ServiceLifetime: () => ServiceLifetime,
  brandInstance: () => brandInstance,
  collection: () => collection,
  createCollectionId: () => createCollectionId,
  createConstructorDescriptor: () => createConstructorDescriptor,
  createFactoryDescriptor: () => createFactoryDescriptor,
  createInstanceDescriptor: () => createInstanceDescriptor,
  createInterfaceId: () => createInterfaceId,
  hasLifetime: () => hasLifetime,
  isAsyncDisposable: () => isAsyncDisposable,
  isCollectionId: () => isCollectionId,
  isConstructorId: () => isConstructorId,
  isConstructorServiceDescriptor: () => isConstructorServiceDescriptor,
  isDisposable: () => isDisposable,
  isFactoryServiceDescriptor: () => isFactoryServiceDescriptor,
  isInstanceServiceDescriptor: () => isInstanceServiceDescriptor,
  isInterfaceId: () => isInterfaceId,
  isServiceDescriptor: () => isServiceDescriptor
});
module.exports = __toCommonJS(src_exports);

// src/types/disposable.ts
function isDisposable(value) {
  if (value === null || value === void 0 || typeof value !== "object")
    return false;
  if ("dispose" in value && typeof value.dispose === "function") {
    return true;
  }
  return false;
}
function isAsyncDisposable(value) {
  if (value === null || value === void 0 || typeof value !== "object")
    return false;
  if ("disposeAsync" in value && typeof value.disposeAsync === "function") {
    return true;
  }
  if (Symbol.asyncDispose in value && typeof value[Symbol.asyncDispose] === "function") {
    return true;
  }
  return false;
}
async function disposeValue(value) {
  if (value === null || value === void 0 || typeof value !== "object")
    return;
  const obj = value;
  if (Symbol.asyncDispose in obj && typeof obj[Symbol.asyncDispose] === "function") {
    await obj[Symbol.asyncDispose]();
    return;
  }
  if ("disposeAsync" in obj && typeof obj.disposeAsync === "function") {
    await obj.disposeAsync();
    return;
  }
  if (isDisposable(value)) {
    value.dispose();
  }
}

// src/types/service_descriptors.ts
var SERVICE_DESCRIPTOR_BRAND = Symbol("SERVICE_DESCRIPTOR_BRAND");
var ServiceLifetime = /* @__PURE__ */ ((ServiceLifetime2) => {
  ServiceLifetime2["Singleton"] = "singleton";
  ServiceLifetime2["Transient"] = "transient";
  ServiceLifetime2["Scoped"] = "scoped";
  return ServiceLifetime2;
})(ServiceLifetime || {});
function createConstructorDescriptor(options) {
  return {
    type: "Constructor",
    ...options,
    aliases: options.aliases,
    [SERVICE_DESCRIPTOR_BRAND]: true
  };
}
function createInstanceDescriptor(options) {
  return {
    type: "Instance",
    ...options,
    aliases: options.aliases,
    [SERVICE_DESCRIPTOR_BRAND]: true
  };
}
function createFactoryDescriptor(options) {
  return {
    type: "Factory",
    autoActivate: options.autoActivate ?? false,
    ...options,
    factory: options.factory,
    aliases: options.aliases,
    [SERVICE_DESCRIPTOR_BRAND]: true
  };
}
function hasLifetime(descriptor, lifetime) {
  if ("lifetime" in descriptor) {
    return descriptor.lifetime === lifetime;
  }
  return false;
}
function isServiceDescriptor(value) {
  return value !== null && typeof value === "object" && SERVICE_DESCRIPTOR_BRAND in value && value[SERVICE_DESCRIPTOR_BRAND] === true;
}
function isConstructorServiceDescriptor(descriptor) {
  return descriptor.type === "Constructor";
}
function isInstanceServiceDescriptor(descriptor) {
  return descriptor.type === "Instance";
}
function isFactoryServiceDescriptor(descriptor) {
  return descriptor.type === "Factory";
}

// src/types/service_identifier.ts
function isConstructorId(id) {
  return typeof id === "function";
}
function isInterfaceId(id) {
  return "symbol" in id;
}
function isCollectionId(id) {
  return "baseId" in id;
}

// src/errors/utils/get_service_name.ts
function getServiceName(identifier) {
  if (isConstructorId(identifier)) {
    return identifier.name;
  }
  if (isInterfaceId(identifier) && identifier.symbol.description) {
    return identifier.symbol.description;
  }
  if (isCollectionId(identifier)) {
    return `${getServiceName(identifier.baseId)}[]`;
  }
  return "unkown";
}

// src/errors/ambiguous_match_error.ts
var AmbiguousMatchError = class extends Error {
  constructor(serviceId) {
    super(
      `Multiple instances are registered for '${getServiceName(serviceId)}'. Unable to resolve a single service using a default strategy.`
    );
    this.name = "AmbiguousMatchError";
  }
};

// src/errors/multiple_dependency_implementations_error.ts
var MultipleDependencyImplementationsError = class extends Error {
  constructor(serviceId, dependencyId) {
    super(
      `Service '${getServiceName(serviceId)}' depends on '${getServiceName(dependencyId)}' which has multiple implementations registered.`
    );
    this.name = "MultipleDependencyImplementationsError";
  }
};

// src/errors/service_not_registered_error.ts
var ServiceNotRegisteredError = class extends Error {
  constructor(serviceId) {
    super(`No service registered for '${getServiceName(serviceId)}'`);
    this.name = "ServiceNotRegisteredError";
  }
};

// src/errors/unresolved_dependency_error.ts
var UnresolvedDependencyError = class extends Error {
  constructor(serviceId, dependencyId) {
    super(
      `Service '${getServiceName(serviceId)}' depends on '${getServiceName(dependencyId)}' which couldn't be resolved.`
    );
    this.name = "UnresolvedDependencyError";
  }
};

// src/contextual_service_locator.ts
var ContextualServiceLocator = class {
  constructor(serviceResolver, scopeId) {
    this.serviceResolver = serviceResolver;
    this.scopeId = scopeId;
  }
  getServices(identifier) {
    return this.serviceResolver.resolveServices(identifier, this.scopeId);
  }
  getRequiredService(identifier) {
    const services = this.getServices(identifier);
    if (!services || services.length === 0) {
      throw new ServiceNotRegisteredError(identifier);
    }
    if (services.length > 1) {
      throw new AmbiguousMatchError(identifier);
    }
    return services[0];
  }
};

// src/service_provider.ts
var ServiceProvider = class _ServiceProvider {
  #locator;
  #scopeId;
  #serviceResolver;
  #onDispose;
  #disposed = false;
  constructor(serviceResolver, onDispose) {
    this.#scopeId = Symbol("Scope");
    this.#serviceResolver = serviceResolver;
    this.#locator = new ContextualServiceLocator(serviceResolver, this.#scopeId);
    this.#onDispose = onDispose;
  }
  /**
   * Retrieves all registered services for the specified identifier.
   * @param identifier - The service identifier
   * @returns Array of service instances
   */
  getServices(identifier) {
    this.#throwIfDisposed();
    return this.#locator.getServices(identifier);
  }
  /**
   * Retrieves a single registered service for the specified identifier.
   * If more than one service is registered, an error is thrown.
   * If no service is registered, an error is thrown.
   *
   * @param identifier - The service identifier
   * @returns The service instance
   */
  getRequiredService(identifier) {
    this.#throwIfDisposed();
    return this.#locator.getRequiredService(identifier);
  }
  /**
   * Creates a new child scope for dependency resolution.
   *
   * Scoped services are instantiated once per scope, allowing for isolated
   * dependency trees. Each scope must be explicitly disposed when no longer needed to prevent memory leaks.
   *
   * @returns A new ServiceProvider with its own scope for resolving services
   */
  createScope() {
    this.#throwIfDisposed();
    return new _ServiceProvider(this.#serviceResolver);
  }
  /**
   * Disposes the current scope and releases all scoped resources.
   *
   * This method awaits async disposal of services that implement AsyncDisposable,
   * and synchronously disposes services that only implement Disposable.
   *
   * Note: This does not affect singleton services which persist for the lifetime
   * of the application, nor does it affect services resolved in parent or sibling scopes.
   */
  async dispose() {
    if (this.#disposed) {
      return;
    }
    await this.#serviceResolver.disposeScope(this.#scopeId);
    await this.#onDispose?.();
    this.#disposed = true;
  }
  async [Symbol.asyncDispose]() {
    await this.dispose();
  }
  #throwIfDisposed() {
    if (this.#disposed) {
      throw new Error("Cannot perform operation on disposed ServiceProvider");
    }
  }
};

// src/resolver/middleware_service_resolver.ts
var MiddlewareServiceResolver = class {
  #serviceDescriptors;
  #middlewares;
  #pipeline;
  constructor(serviceDescriptors, middlewares) {
    this.#serviceDescriptors = serviceDescriptors;
    this.#middlewares = middlewares;
    this.#pipeline = middlewares.reduceRight(
      (processNext, currentMiddleware) => (context) => currentMiddleware.handle(context, () => processNext(context)),
      () => null
    );
  }
  /**
   * Resolves all services matching the given identifier.
   * @param identifier - The service identifier to resolve
   * @param scopeId - The current scope identifier
   * @returns Array of resolved service instances
   */
  resolveServices(identifier, scopeId) {
    return this.#getServiceDescriptorsViaIdentifier(identifier).map((descriptor) => ({
      serviceIdentifier: identifier,
      serviceDescriptor: descriptor,
      scopeId,
      serviceResolver: this
    })).map(this.#pipeline).filter(Boolean);
  }
  #getServiceDescriptorsViaIdentifier(identifier) {
    return [...this.#serviceDescriptors].filter((descriptor) => {
      if (isConstructorId(identifier) && isConstructorServiceDescriptor(descriptor)) {
        return descriptor.implementation === identifier;
      }
      if (isCollectionId(identifier)) {
        return descriptor.aliases?.some((alias) => identifier.baseId === alias);
      }
      return descriptor.aliases?.some((alias) => identifier === alias);
    });
  }
  async disposeScope(scopeId) {
    const results = await Promise.allSettled(
      this.#middlewares.map(async (middleware) => {
        if ("disposeScope" in middleware && typeof middleware.disposeScope === "function") {
          await middleware.disposeScope(scopeId);
        }
      })
    );
    const failures = results.filter((r) => r.status === "rejected");
    if (failures.length > 0) {
      throw new AggregateError(
        failures.map((f) => f.reason),
        `${failures.length} middleware(s) failed to dispose scope`
      );
    }
  }
  async dispose() {
    const results = await Promise.allSettled(
      this.#middlewares.map((middleware) => disposeValue(middleware))
    );
    const failures = results.filter((r) => r.status === "rejected");
    if (failures.length > 0) {
      throw new AggregateError(
        failures.map((f) => f.reason),
        `${failures.length} middleware(s) failed to dispose`
      );
    }
  }
};

// src/resolver/middleware/singleton_resolution_middleware.ts
var SingletonResolutionMiddleware = class {
  #instances = /* @__PURE__ */ new Map();
  handle(context, next) {
    if (!hasLifetime(context.serviceDescriptor, "singleton" /* Singleton */)) {
      return next();
    }
    if (this.#instances.has(context.serviceDescriptor)) {
      return this.#instances.get(context.serviceDescriptor);
    }
    const service = next();
    if (service)
      this.#instances.set(context.serviceDescriptor, service);
    return service;
  }
  async disposeAsync() {
    const results = await Promise.allSettled(
      [...this.#instances.values()].map((instance) => disposeValue(instance))
    );
    this.#instances.clear();
    const failures = results.filter((r) => r.status === "rejected");
    if (failures.length > 0) {
      throw new AggregateError(
        failures.map((f) => f.reason),
        `${failures.length} service(s) failed to dispose`
      );
    }
  }
};

// src/resolver/middleware/instance_resolution_middleware.ts
var InstanceResolutionMiddleware = class {
  handle(context, next) {
    if (!isInstanceServiceDescriptor(context.serviceDescriptor)) {
      return next();
    }
    return context.serviceDescriptor.instance;
  }
};

// src/resolver/middleware/constructor_resolution_middleware.ts
var ConstructorResolutionMiddleware = class {
  handle(context, next) {
    if (!isConstructorServiceDescriptor(context.serviceDescriptor)) {
      return next();
    }
    const constructorDependencies = context.serviceDescriptor.dependencies.map((dependency) => {
      if (isCollectionId(dependency)) {
        return context.serviceResolver.resolveServices(dependency.baseId, context.scopeId);
      }
      const services = context.serviceResolver.resolveServices(dependency, context.scopeId);
      if (!services || services.length === 0) {
        throw new UnresolvedDependencyError(context.serviceIdentifier, dependency);
      }
      if (services.length > 1) {
        throw new MultipleDependencyImplementationsError(context.serviceIdentifier, dependency);
      }
      return services[0];
    });
    return new context.serviceDescriptor.implementation(...constructorDependencies);
  }
};

// src/resolver/middleware/scoped_resolution_middleware.ts
var ScopedResolutionMiddleware = class {
  #scopedInstances = /* @__PURE__ */ new Map();
  handle(context, next) {
    if (!hasLifetime(context.serviceDescriptor, "scoped" /* Scoped */)) {
      return next();
    }
    let scopeMap = this.#scopedInstances.get(context.scopeId);
    if (!scopeMap) {
      scopeMap = /* @__PURE__ */ new Map();
      this.#scopedInstances.set(context.scopeId, scopeMap);
    }
    if (scopeMap.has(context.serviceDescriptor)) {
      return scopeMap.get(context.serviceDescriptor);
    }
    const service = next();
    if (service)
      scopeMap.set(context.serviceDescriptor, service);
    return service;
  }
  async disposeScope(scopeId) {
    const scopeMap = this.#scopedInstances.get(scopeId);
    if (!scopeMap)
      return;
    const results = await Promise.allSettled(
      [...scopeMap.values()].map((instance) => disposeValue(instance))
    );
    this.#scopedInstances.delete(scopeId);
    const failures = results.filter((r) => r.status === "rejected");
    if (failures.length > 0) {
      throw new AggregateError(
        failures.map((f) => f.reason),
        `${failures.length} service(s) failed to dispose`
      );
    }
  }
  async disposeAsync() {
    const results = await Promise.allSettled(
      [...this.#scopedInstances.keys()].map((scopeId) => this.disposeScope(scopeId))
    );
    this.#scopedInstances.clear();
    const failures = results.filter((r) => r.status === "rejected");
    if (failures.length > 0) {
      throw new AggregateError(
        failures.map((f) => f.reason),
        `${failures.length} scope(s) failed to dispose`
      );
    }
  }
};

// src/resolver/middleware/factory_resolution_middleware.ts
var FactoryResolutionMiddleware = class {
  handle(context, next) {
    if (!isFactoryServiceDescriptor(context.serviceDescriptor)) {
      return next();
    }
    const contextualLocator = new ContextualServiceLocator(
      context.serviceResolver,
      context.scopeId
    );
    return context.serviceDescriptor.factory(contextualLocator);
  }
};

// src/resolver/create_default_service_resolver.ts
var createDefaultServiceResolver = (serviceDescriptors) => {
  return new MiddlewareServiceResolver(serviceDescriptors, [
    new InstanceResolutionMiddleware(),
    new SingletonResolutionMiddleware(),
    new ScopedResolutionMiddleware(),
    new FactoryResolutionMiddleware(),
    new ConstructorResolutionMiddleware()
  ]);
};

// src/decorators/service.ts
var serviceMetadata = /* @__PURE__ */ new WeakMap();
function Service(metadata) {
  return (target, context) => {
    if (context) {
      if (context.kind !== "class") {
        throw new Error("Service decorator can only be used on classes.");
      }
    }
    serviceMetadata.set(target, metadata);
  };
}
function isServiceDecorated(target) {
  return serviceMetadata.has(target);
}
function getServiceMetadata(serviceClass) {
  const metadata = serviceMetadata.get(serviceClass);
  if (!metadata) {
    throw new Error(`Class ${serviceClass.name} is not decorated with @Service`);
  }
  return metadata;
}

// src/decorators/implements.ts
var interfaceImplementations = /* @__PURE__ */ new WeakMap();
var Implements = (interfaceId) => (target, context) => {
  if (context) {
    if (context.kind !== "class") {
      throw new Error("Implements decorator can only be used on classes.");
    }
  }
  let interfaces = interfaceImplementations.get(target);
  if (!interfaces) {
    interfaces = /* @__PURE__ */ new Set();
    interfaceImplementations.set(target, interfaces);
  }
  interfaces.add(interfaceId);
};
function getImplementedInterfaces(ctor) {
  const result = /* @__PURE__ */ new Set();
  let current = ctor;
  while (current && current !== Object.prototype) {
    const interfaces = interfaceImplementations.get(current);
    if (interfaces && interfaces.size > 0) {
      for (const id of interfaces) {
        result.add(id);
      }
    }
    current = Object.getPrototypeOf(current);
  }
  return Array.from(result);
}

// src/utils/build_constructor_service_descriptor.ts
function buildConstructorDescriptor(constructor) {
  const metadata = getServiceMetadata(constructor);
  const implemented = getImplementedInterfaces(constructor);
  return createConstructorDescriptor({
    implementation: constructor,
    dependencies: metadata.dependencies,
    lifetime: metadata.lifetime,
    aliases: implemented,
    autoActivate: metadata.autoActivate ?? false
  });
}

// src/validation/composite_validator.ts
var CompositeValidator = class {
  constructor(validators) {
    this.validators = validators;
  }
  name = "CompositeValidator";
  validate(context) {
    const allErrors = this.validators.flatMap((validator) => {
      const result = validator.validate(context);
      return result.isValid ? [] : result.errors;
    });
    return {
      isValid: allErrors.length === 0,
      errors: allErrors
    };
  }
};

// src/validation/utils.ts
function toDescriptorNode(descriptor) {
  const identifiers = [
    ...descriptor.aliases ?? [],
    ...isConstructorServiceDescriptor(descriptor) ? [descriptor.implementation] : []
  ];
  return {
    identifiers,
    dependencyIds: isConstructorServiceDescriptor(descriptor) ? descriptor.dependencies : [],
    lifetime: "lifetime" in descriptor ? descriptor.lifetime : "transient" /* Transient */,
    originalDescriptor: descriptor
  };
}
function prepareValidationData(descriptors) {
  const nodes = [...descriptors].map(toDescriptorNode);
  const lookup = nodes.reduce((map, node) => {
    node.identifiers.forEach((identifier) => {
      const arr = map.get(identifier) ?? [];
      arr.push(node);
      map.set(identifier, arr);
    });
    return map;
  }, /* @__PURE__ */ new Map());
  return {
    nodes,
    lookup
  };
}
function createValidationContext(descriptors) {
  return {
    descriptors,
    validationData: prepareValidationData(descriptors)
  };
}

// src/validation/validators/dependency_existence_validator.ts
var DependencyExistenceValidator = class {
  name = "DependencyExistenceValidator";
  validate({ validationData }) {
    const { nodes, lookup } = validationData;
    const errors = nodes.flatMap(
      (node) => node.dependencyIds.filter((depId) => !isCollectionId(depId)).filter((depId) => !lookup.has(depId)).map((depId) => new UnresolvedDependencyError(node.identifiers[0], depId))
    );
    return {
      isValid: errors.length === 0,
      errors
    };
  }
};

// src/validation/validators/single_implementation_validator.ts
var SingleImplementationValidator = class {
  name = "SingleImplementationValidator";
  validate({ validationData }) {
    const { nodes, lookup } = validationData;
    const errors = nodes.flatMap(
      (node) => node.dependencyIds.filter((depId) => !isCollectionId(depId)).filter((depId) => {
        const impls = lookup.get(depId);
        return impls && impls.length > 1;
      }).map((depId) => new MultipleDependencyImplementationsError(node.identifiers[0], depId))
    );
    return {
      isValid: errors.length === 0,
      errors
    };
  }
};

// src/validation/errors/circular_dependency_error.ts
var CircularDependencyError = class extends Error {
  constructor(cycle) {
    const cycleNames = cycle.map((id) => getServiceName(id)).join(" -> ");
    super(`Circular dependency detected: ${cycleNames}`);
    this.name = "CircularDependencyError";
  }
};

// src/validation/validators/circular_dependency_validator.ts
var CircularDependencyValidator = class {
  name = "CircularDependencyValidator";
  validate({ validationData }) {
    const { nodes } = validationData;
    const errors = [];
    const idToNodeMap = /* @__PURE__ */ new Map();
    nodes.forEach((node) => {
      node.identifiers.forEach((id) => {
        idToNodeMap.set(id, node);
      });
    });
    const inStack = /* @__PURE__ */ new Set();
    const visited = /* @__PURE__ */ new Set();
    nodes.flatMap((node) => node.identifiers).filter((id) => !visited.has(id)).forEach((id) => {
      const cycle = this.#findCircularDependency(id, inStack, visited, idToNodeMap);
      if (cycle.length > 0) {
        errors.push(new CircularDependencyError(cycle));
      }
    });
    return {
      isValid: errors.length === 0,
      errors
    };
  }
  #findCircularDependency(id, inStack, visited, idToNodeMap) {
    if (inStack.has(id))
      return [id];
    if (visited.has(id))
      return [];
    inStack.add(id);
    visited.add(id);
    const node = idToNodeMap.get(id);
    if (!node) {
      inStack.delete(id);
      return [];
    }
    for (const depId of node.dependencyIds) {
      const targetId = isCollectionId(depId) ? depId.baseId : depId;
      const cycle = this.#findCircularDependency(targetId, inStack, visited, idToNodeMap);
      if (cycle.length > 0) {
        inStack.delete(id);
        return [id, ...cycle];
      }
    }
    inStack.delete(id);
    return [];
  }
};

// src/validation/index.ts
function createDefaultValidator() {
  return new CompositeValidator([
    new DependencyExistenceValidator(),
    new SingleImplementationValidator(),
    new CircularDependencyValidator()
  ]);
}
function validateServiceDescriptors(descriptors) {
  const validator = createDefaultValidator();
  const validationContext = createValidationContext(descriptors);
  return validator.validate(validationContext);
}

// src/service_collection.ts
var ServiceCollection = class {
  #serviceDescriptors = /* @__PURE__ */ new Set();
  /**
   * Gets the number of registered service descriptors.
   */
  get size() {
    return this.#serviceDescriptors.size;
  }
  /**
   * Adds pre-configured service descriptors to the collection.
   *
   * @param descriptors - Service descriptors to add
   * @returns This service collection instance for method chaining
   */
  add(...descriptors) {
    descriptors.forEach((descriptor) => this.#serviceDescriptors.add(descriptor));
    return this;
  }
  /**
   * Adds classes decorated with `@Service` or `@Injectable` to the collection.
   * Automatically creates service descriptors using the class's decorator metadata.
   *
   * @param ctors - Constructor classes to add
   * @returns This service collection instance for method chaining
   * @throws Error if any constructor is not properly decorated
   */
  addClass(...ctors) {
    const descriptors = ctors.map(buildConstructorDescriptor);
    this.add(...descriptors);
    return this;
  }
  /**
   * Validates the service collection without building a provider.
   * Useful for testing or early validation during application startup.
   *
   * @returns Validation result indicating success or containing errors
   */
  validate() {
    return validateServiceDescriptors(this.#serviceDescriptors);
  }
  /**
   * Creates a new ServiceProvider with all registered services.
   * Validates service dependencies before building the provider.
   *
   * @returns A configured ServiceProvider
   * @throws AggregateError if validation fails
   */
  build() {
    const validationResult = this.validate();
    if (!validationResult.isValid) {
      const errorMessages = validationResult.errors.map((error) => error.message).join("; ");
      throw new AggregateError(
        validationResult.errors,
        `Service validation failed with ${validationResult.errors.length} errors: ${errorMessages}`
      );
    }
    const resolver = createDefaultServiceResolver(this.#serviceDescriptors);
    const provider = new ServiceProvider(resolver, () => resolver.dispose());
    for (const descriptor of this.#serviceDescriptors) {
      if (isConstructorServiceDescriptor(descriptor) && descriptor.autoActivate) {
        provider.getRequiredService(descriptor.implementation);
      }
    }
    return provider;
  }
};

// src/index.ts
var createInterfaceId = (id) => {
  return {
    symbol: Symbol(id)
  };
};
var createCollectionId = (interfaceId) => {
  return {
    baseId: interfaceId
  };
};
var collection = createCollectionId;
var isCollectionToken = (token) => {
  return "baseId" in token;
};
var injectableMetadata = /* @__PURE__ */ new WeakMap();
function Injectable(id, dependencies) {
  return function(constructor, ctx) {
    Implements(id)(constructor, ctx);
    Service({ dependencies, lifetime: "singleton" /* Singleton */, autoActivate: true })(
      constructor,
      ctx
    );
  };
}
var dependenciesArePresent = (cwds, instances) => {
  const allSymbols = /* @__PURE__ */ new Set([...cwds.map((cwd) => cwd.id.symbol), ...instances.keys()]);
  const cwsWithUnmetDeps = cwds.filter(
    (cwd) => cwd.dependencies.some((dep) => {
      if (isCollectionToken(dep)) {
        return false;
      }
      return !allSymbols.has(dep.symbol);
    })
  );
  if (cwsWithUnmetDeps.length === 0) {
    return;
  }
  const messages = cwsWithUnmetDeps.map((cwd) => {
    const unmetDeps = cwd.dependencies.filter((dep) => !isCollectionToken(dep) && !allSymbols.has(dep.symbol)).map((dep) => dep.symbol.description);
    return `Class ${cwd.cls.name} (interface ${cwd.id.symbol.description}) depends on interfaces [${unmetDeps}] that weren't added to the init method.`;
  });
  throw new Error(messages.join("\n"));
};
var noCircularDependencies = (cwds, instances) => {
  const inStack = /* @__PURE__ */ new Set();
  const hasCircularDependency = (symbol) => {
    if (inStack.has(symbol)) {
      return true;
    }
    inStack.add(symbol);
    const cwd = cwds.find((c) => c.id.symbol === symbol);
    if (!cwd && instances.has(symbol)) {
      inStack.delete(symbol);
      return false;
    }
    if (!cwd)
      throw new Error(`assertion error: dependency ID missing ${symbol.description}`);
    for (const dep of cwd.dependencies) {
      if (isCollectionToken(dep)) {
        if (hasCircularDependency(dep.baseId.symbol)) {
          return true;
        }
      } else if (hasCircularDependency(dep.symbol)) {
        return true;
      }
    }
    inStack.delete(symbol);
    return false;
  };
  for (const cwd of cwds) {
    if (hasCircularDependency(cwd.id.symbol)) {
      throw new Error(
        `Circular dependency detected between interfaces (${Array.from(inStack).map(
          (s) => s.description
        )}), starting with '${cwd.id.symbol.description}' (class: ${cwd.cls.name}).`
      );
    }
  }
};
var brandInstance = (id, instance) => {
  injectableMetadata.set(instance, { id, dependencies: [] });
  return instance;
};
var Container = class {
  #serviceDescriptors = /* @__PURE__ */ new Set();
  #provider = new ServiceProvider(
    createDefaultServiceResolver(this.#serviceDescriptors)
  );
  /**
   * addInstances allows you to add pre-initialized objects to the container.
   * This is useful when you want to keep mandatory parameters in class' constructor (e.g. some runtime objects like server connection).
   * addInstances accepts a list of any objects that have been "branded" by the `brandInstance` method
   */
  addInstances(...instances) {
    for (const instance of instances) {
      const metadata = injectableMetadata.get(instance);
      if (!metadata) {
        throw new Error(
          "assertion error: addInstance invoked without branded object, make sure all arguments are branded with `brandInstance`"
        );
      }
      this.#serviceDescriptors.add(
        createInstanceDescriptor({
          instance,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- temporary until we deprecate container
          aliases: metadata.id ? [metadata.id] : []
        })
      );
    }
  }
  /**
   * instantiate accepts list of classes, validates that they can be managed by the container
   * and then initialized them in such order that dependencies of a class are initialized before the class
   */
  instantiate(...classes) {
    const undecorated = classes.filter((c) => !isServiceDecorated(c)).map((c) => c.name);
    if (undecorated.length) {
      throw new Error(`Classes [${undecorated}] are not decorated with @Injectable.`);
    }
    const serviceDescriptors = classes.map(buildConstructorDescriptor);
    const classesWithDeps = serviceDescriptors.map((x) => ({
      cls: x.implementation,
      id: x.aliases?.[0],
      dependencies: x.dependencies
    }));
    const validators = [dependenciesArePresent, noCircularDependencies];
    const instances = [...this.#serviceDescriptors].flatMap((x) => x.aliases).reduce((map, alias) => {
      if (alias !== void 0 && "symbol" in alias && typeof alias.symbol === "symbol") {
        map.set(alias.symbol, []);
      }
      return map;
    }, /* @__PURE__ */ new Map());
    validators.forEach((v) => v(classesWithDeps, instances));
    for (const descriptor of serviceDescriptors) {
      this.#serviceDescriptors.add(descriptor);
    }
    for (const descriptor of serviceDescriptors) {
      this.#provider.getServices(descriptor.implementation);
    }
  }
  register(...registrationItems) {
    const errors = [];
    const descriptors = [];
    for (const registrationItem of registrationItems) {
      try {
        const descriptor = this.#resolveServiceDescriptor(registrationItem);
        descriptors.push(descriptor);
      } catch (error) {
        errors.push(error instanceof Error ? error : new Error(String(error)));
      }
    }
    if (errors.length > 0) {
      throw new AggregateError(errors, "Could not register all items");
    }
    descriptors.forEach((descriptor) => this.#serviceDescriptors.add(descriptor));
  }
  get(id) {
    return this.#provider.getRequiredService(id);
  }
  getAll(id) {
    return this.#provider.getServices(id);
  }
  #resolveServiceDescriptor(item) {
    if (isServiceDescriptor(item)) {
      return item;
    }
    if (isServiceDecorated(item)) {
      return buildConstructorDescriptor(item);
    }
    throw new Error(
      `Unable to register item of type ${item.constructor?.name || typeof item}. Classes must be decorated with @Service or @Injectable, or you must provide a valid ServiceDescriptor.`
    );
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Container,
  Implements,
  Injectable,
  Service,
  ServiceCollection,
  ServiceLifetime,
  brandInstance,
  collection,
  createCollectionId,
  createConstructorDescriptor,
  createFactoryDescriptor,
  createInstanceDescriptor,
  createInterfaceId,
  hasLifetime,
  isAsyncDisposable,
  isCollectionId,
  isConstructorId,
  isConstructorServiceDescriptor,
  isDisposable,
  isFactoryServiceDescriptor,
  isInstanceServiceDescriptor,
  isInterfaceId,
  isServiceDescriptor
});
//# sourceMappingURL=index.js.map